import React from 'react';
import { StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { Card, TouchableRipple } from 'react-native-paper';
import i18n from 'i18n-js';
import { Logger } from 'aws-amplify';

import { hexagrams, Guà, Identity } from '../constants/hexagram';
import Datagram from './datagram';
import useTranslation from '../hooks/translation';

const logger = new Logger('hexagram');

export interface Props extends Identity {
  /** The hexagram style */
  style?: StyleProp<ViewStyle>;
  /** Function to call in case of item selected */
  onPress?: (index: number) => void;
  /** Function to call in case of item pressed for long */
  onLongPress?: (index: number) => void;
}

export const styles = StyleSheet.create({
  container: {
    // backgroundColor: '#ff808026',
    // flex: 1,
    // flexDirection: 'row',
    // justifyContent: 'center'
  },
  content: {
    backgroundColor: '#ff808026',
    paddingBottom: 0
  },
  pictogram: {},
  title: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontFamily: 'King_Luau',
    fontSize: 22,
    paddingLeft: -10,
    marginRight: 8,
    minHeight: 90
  }
});

const renderTouchable = (
  item: JSX.Element,
  onPress?: () => void,
  onLongPress?: () => void
) => {
  return (
    ((onPress || onLongPress) && (
      <TouchableRipple
        onPress={() => logger.debug('pressed touchable')}
        onLongPress={() => logger.debug('long pressed touchable')}
        rippleColor="rgba(0, 0, 0, .32)"
      >
        {item}
      </TouchableRipple>
    )) ||
    item
  );
};

const renderItem = (
  number: number,
  style?: StyleProp<ViewStyle>,
  onPress?: (index: number) => void,
  onLongPress?: (index: number) => void
): JSX.Element | null => {
  const hexagram: Guà = hexagrams[number - 1];

  const pressed = () => onPress && onPress(number);
  const longPressed = () => onLongPress && onLongPress(number);

  const translation = useTranslation();

  return hexagram && translation !== null
    ? renderTouchable(
        // <View style={style}><Text>{hexagram.name}</Text></View>
        <Card
          elevation={10}
          style={style}
          onPress={onPress ? pressed : undefined}
          onLongPress={onLongPress ? longPressed : undefined}
        >
          <Card.Title
            title={`${hexagram.number}. ${i18n.t(`${number}.title`)}`}
            titleNumberOfLines={3}
            titleStyle={styles.title}
          />
          <Card.Content style={styles.content}>
            <Datagram lines={hexagram.lines} key={hexagram.number.toString()} />
          </Card.Content>
        </Card>,
        pressed,
        longPressed
      )
    : null;
};

const Hexagram = ({ number, style, onPress, onLongPress }: Props) =>
  renderItem(number, style, onPress, onLongPress);

export default Hexagram;
